import React, { Component } from 'react'
import cx from 'classnames'
import actions from 'redux/actions'
import { connect } from 'redaction'
import { links, formatPrice, isNotEmpty, constants } from 'common/helpers'

import Text from 'components/_new/typography/Text/Text'
import Button from 'components/_new/Button/Button'
import Box from 'components/_new/layout/Box/Box'

import Price from 'components/text/Price/Price'

import messages from './messages'
import s from './Footer.scss'


class CartOverlayFooter extends Component {

  submitCart = () => {
    const { pathname } = this.props

    actions.models.cart.fetch()
      .then(({ items: { subscription, products } }) => {
        actions.models.cart.close()

        if (!isNotEmpty(products) && !subscription) {
          if (pathname !== links.subscription.smartSearch) {
            actions.models.router.push(links.subscription.smartSearch)
          }
        }
        else if (subscription) {
          actions.models.router.push(isNotEmpty(products) ? links.checkout : links.subscribe)
        }
        else {
          actions.models.router.push(links.checkout)
        }
      })
  }

  renderBottom() {
    const { cart: { items: { subscription }, totalPrice, shipping, appliedPriceRules = {} } } = this.props

    const isTossInOffer = Boolean(appliedPriceRules.TOSSIN)

    if (isTossInOffer) {
      return (
        <Text
          className={s.additionalInfo}
          message={messages.freeShipping}
          uppercase
          html
        />
      )
    }

    // TODO this is big hack! F$%#@!
    const subscriptionPrice = subscription && subscription.price || 0

    const qualifyAmount   = 5000
    const itemsPrice      = totalPrice - subscriptionPrice - shipping // TODO need to calculate on backend
    const isQualified     = itemsPrice >= qualifyAmount
    const offToQualify    = qualifyAmount - itemsPrice

    return (
      <div className={s.additionalInfo}>
        {
          isQualified && (
            <Text message={messages.qualifiedFor} />
          )
        }
        <Text
          className={s.accentText}
          message={messages.standardShipping}
          color="brand"
          uppercase
        />
        {
          !isQualified && (
            <Text
              message={messages.addToQualify}
              values={{ amount: formatPrice(offToQualify, true) }}
              html
            />
          )
        }
      </div>
    )
  }

  render() {
    const { cart: { isFetching, discount, shipping, totalPrice, totalCount } } = this.props

    const areItemsExist = Boolean(totalCount)
    const submitLabel = areItemsExist ? messages.checkout : messages.shopNow

    return (
      <div className={s.footerContainer}>
        <div className={s.footer}>
          {
            Boolean(shipping) && (
              <div className={s.totalRow}>
                <Text message={messages.shipping} />
                <Price loading={isFetching} isCents>{shipping}</Price>
              </div>
            )
          }
          {
            Boolean(discount) && (
              <div className={cx(s.totalRow, s.discount)}>
                <Text message={messages.discount} />
                <Price loading={isFetching} isCents>{discount}</Price>
              </div>
            )
          }
          {
            areItemsExist && (
              <div className={cx(s.totalRow, s.total)}>
                <Text message={messages.total} />
                <Price id="totalPrice" loading={isFetching} isCents>{totalPrice}</Price>
              </div>
            )
          }
          <Box mt="24">
            <Button
              loading={isFetching}
              disabled={isFetching}
              dataTestId={constants.testIds.payment.checkoutButton}
              title={submitLabel}
              weight="normal"
              color="brand"
              size="sm"
              fullWidth
              uppercase
              onClick={this.submitCart}
            />
          </Box>
          {
            areItemsExist && this.renderBottom()
          }
        </div>
      </div>
    )
  }
}


export default connect({
  cart: 'models.cart',
  pathname: 'routing.location.pathname',
}, { pure: false })(CartOverlayFooter)
